import _mapValues from "lodash/mapValues";
import isPending from './isPending';
import { connect } from 'react-redux';
/**
 * Maps options to application state,
 * specifically whether passed action types are pending in state
 *
 * @param  {Object} options - options with format { prop: [actionType]}
 * @return {Object} - { [string actionType]: [bool isPending] }
 */

function mapStateToProps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (_ref) {
    var pendingActions = _ref.pendingActions;
    return _mapValues(options, function (action) {
      return isPending(pendingActions, action);
    });
  };
}
/**
 * Decorates component with required state in props
 * Requred option format:
 * — `object { [string propName]: array|string actionType }`
 *
 * @param  {Object} options - options
 * @return {Object} - react component with connected state
 */

export default function connectPending(options) {
  var props = mapStateToProps(options);
  return connect(props, null);
}